import { log } from "../../utils/log";
import axios from "../axiosApi";
import config from "../../config";
import {
    GET_FREQUENCY_CALL_PRINTING, GET_FREQUENCY_CALL_PRINTING_SUCCESS,
    FETCH_ATA_PRESENCA, RECEIVE_ATA_PRESENCA,
    FETCH_DOF_CONTENTS, RECEIVE_DOF_CONTENTS,
    FETCH_BATCH_DOF_CONTENTS, RECEIVE_BATCH_DOF_CONTENTS,
    FETCH_ATA_PRESENCA_BATCH, RECEIVE_ATA_PRESENCA_BATCH,
    TOGGLE_OK_SECRETARIA
} from "../actionTypes";



export function dgetFrequencyCallPrinting() {
    return {
        type: GET_FREQUENCY_CALL_PRINTING
    }
}

export function dgetFrequencyCallForPrintingSuccess(alunos : any, frequencia: any, header: any, content: any) {
    
    let datas : any[] = [];
    let auxdata = 0;
    let minlength = 0;
    
    console.log('dispatched', alunos, frequencia, header, content);
    
    
    content.map((c: any, ix: number) => {
        let x = 0;
        while (x < c.QtyHours) {
            datas.push(c.Date);
            x += 1;
        }
    });
    while (datas.length < header[0].disciplineModule.WorkloadPresential) {
        datas.push(null)
    }
    
    
    // para cada aluno
    alunos.map((a: any, aix: number) => {
        
        // inicializa frequencia do aluno
        a.frequencia = [];
        
        
        // busca frequencia do aluno, vindas de classes regulares
        const f: any = frequencia.filter( (ff: any)  => ff.DisciplineEntree_id === a.deeId && ff.Type === 1);
        
        if (aix === 1) {
            //fo  debugger;
        }
        
        // debugger;
        
        let fa: any[] = [];
        // para cada aula
        content.map((c: any, ix: number) => {
            // busca frequencia da aula
            fa = f.filter( (f1: any) => c.id === f1.DisciplineOfferContent_id);
            
            // preenche com frequencia/registros existentes
            let fr = [];
            while (fr.length < fa.length) {
                fr.push({
                    status: fa[fr.length].Status,
                    dt: fa[fr.length].Date,
                    dofCid: fa[fr.length].DisciplineOfferContent_id,
                    id: fa[fr.length].id
                })
            }
            //TODO: adicionar aulas nao registradas
            while (fr.length < c.QtyHours) {
                fr.push({status: '-', dt: c.Date, dofCid: c.id, id: 0})
            }
            
            // atribui ao aluno
            alunos[aix].frequencia = alunos[aix].frequencia.concat(fr);
            
        });
        //
        while (alunos[aix].frequencia.length < header[0].disciplineModule.WorkloadPresential) {
            alunos[aix].frequencia.push({status: ' ', dt: null, dofCid: null, id: 0})
        }
        
        let cont = content? content: []
        let alun = alunos? alunos : []
        let freq = datas? datas : []
        let head = header? header : {}
        
        return {
            type: GET_FREQUENCY_CALL_PRINTING_SUCCESS,
            payload : { alunos: alun, datas: freq, header: head, conteudo: cont }
        }
    });
}


export const getFrequencyCallForPrinting = ( dofId : number) => {
    log('getFrequencyCallForPrinting');
    
        /*
        /api/DisciplineOffers?filter={ "where":  { "id":1109 }, "include": [ {"disciplineEntree":[  {"disciplineEntreeFrequency": "disciplineOfferContent" },  {"disciplineEntreeAvaliacoes":"disciplineOfferContent"} , { "enrollment": {"enrollmentInLevel":"person"} }   ]}   , {"disciplineModule" :  {"discipline": {"level":"schoolAuthorization" }   } }     ]  }
         */
    
    
    return async (dispatch: any,getState :any) => {
            dispatch(dgetFrequencyCallPrinting());
            

            axios.get(config.BASE_URL + `/DisciplineOffers/getStudentsListForFrequencyCallPrint?params={"dofId": ${dofId}}` )
                .then(alunosresponse => {
                    console.log("alunosResponse", alunosresponse.data);
                    
                    axios.get(config.BASE_URL + `/DisciplineOffers/getFrequencyCallForPrint?params={"dofId": ${dofId}}` )
                        .then(frequenciaresponse => {
                            console.log('frequencia', frequenciaresponse.data)
                            
                            axios.get(config.BASE_URL + `/DisciplineOffers?filter={ "where": { "id" : ${dofId} } , "include": [ {"classOffer": "level" } ,  {"discipline": "level" }, "disciplineModule", "teacher", "period"   ] }` )
                                .then(headeresponse => {
                                    console.log('header', headeresponse.data)
                                    
                                    axios.get(config.BASE_URL + `/DisciplineOfferContents?filter={ "where": { "DisciplineOffer_id" : ${dofId} },  "order": "Date" }` )
                                        .then(contentresponse => {
                                            console.log('content', contentresponse.data)
                                            
                                            dispatch(dgetFrequencyCallForPrintingSuccess(alunosresponse.data, frequenciaresponse.data, headeresponse.data, contentresponse.data));
                                            
                                        })
                                })
                            
                        })
                        .catch( err => console.log(err));
                    
                    
                }).catch(err => console.log(err));
        }
}


export const fetchDofContents = (dofId: number) => {
    return async (dispatch: any) => {
        dispatch({ type: FETCH_DOF_CONTENTS });
        try {
            console.log('[AtaPresenca] fetchDofContents dofId:', dofId);
            const filter = encodeURIComponent(JSON.stringify({
                where: { DisciplineOffer_id: dofId },
                order: "Date"
            }));
            const response = await axios.get(`/DisciplineOfferContents?filter=${filter}`);
            console.log('[AtaPresenca] dofContents:', response.data?.length, 'registros');
            dispatch({ type: RECEIVE_DOF_CONTENTS, payload: response.data });
        } catch (e) {
            console.error("[AtaPresenca] fetchDofContents ERROR", e);
            dispatch({ type: RECEIVE_DOF_CONTENTS, payload: [] });
        }
    }
}


export const getAtaPresencaData = (dofId: number, dofContentId: number) => {
    return async (dispatch: any) => {
        dispatch({ type: FETCH_ATA_PRESENCA });
        try {
            // 1. Fetch DisciplineOffer header (same includes as getFrequencyCallForPrinting)
            const headerResponse = await axios.get(config.BASE_URL + `/DisciplineOffers?filter={ "where": { "id" : ${dofId} } , "include": [ {"classOffer": "level" } ,  {"discipline": "level" }, "disciplineModule", "teacher", "period"   ] }`);
            const header = headerResponse.data[0] || {};

            // 2. Fetch the selected DisciplineOfferContent
            const contentResponse = await axios.get(config.BASE_URL + `/DisciplineOfferContents/${dofContentId}`);
            const content = contentResponse.data;

            // 3. Fetch students list and frequency data
            const alunosResponse = await axios.get(
                config.BASE_URL + `/DisciplineOffers/getStudentsListForFrequencyCallPrint?params={"dofId": ${dofId}}`
            );
            const frequenciaResponse = await axios.get(
                config.BASE_URL + `/DisciplineOffers/getFrequencyCallForPrint?params={"dofId": ${dofId}}`
            );

            // 4. Build all students with per-hour presence array
            const alunos = alunosResponse.data || [];
            const frequencia = frequenciaResponse.data || [];
            const qtyHours = content.QtyHours || 1;

            const alunosComFrequencia: any[] = [];
            alunos.forEach((aluno: any) => {
                // Get all deef records for this student + content (Type 1 = regular class)
                const freq = frequencia.filter(
                    (f: any) => f.DisciplineEntree_id === aluno.deeId
                        && f.DisciplineOfferContent_id === dofContentId
                        && f.Type === 1
                );
                // Build presence array: one entry per hour
                const presencas: boolean[] = [];
                for (let i = 0; i < qtyHours; i++) {
                    presencas.push(freq[i] ? freq[i].Status === 1 : false);
                }
                alunosComFrequencia.push({
                    name: aluno.Name || aluno.name || '',
                    deeId: aluno.deeId,
                    presencas
                });
            });

            // Filter out students with zero presence, keep partial and full
            const alunosComPresenca = alunosComFrequencia.filter(
                (a: any) => a.presencas.some((p: boolean) => p)
            );

            // Sort alphabetically
            alunosComPresenca.sort((a: any, b: any) => a.name.localeCompare(b.name));

            dispatch({
                type: RECEIVE_ATA_PRESENCA,
                payload: { header, content, alunos: alunosComPresenca }
            });
        } catch (e) {
            console.error("getAtaPresencaData ERROR", e);
            dispatch({ type: RECEIVE_ATA_PRESENCA, payload: null });
        }
    }
}


export const markAtaGerada = (dofContentId: number) => {
    return async (dispatch: any) => {
        try {
            await axios.patch(`/DisciplineOfferContents/${dofContentId}`, { isAtaGerada: true });
        } catch (e) {
            console.error("markAtaGerada ERROR", e);
        }
    }
}


export const toggleOkSecretaria = (contentId: number, currentValue: boolean) => {
    return async (dispatch: any) => {
        const newValue = !currentValue;
        // Optimistic update
        dispatch({ type: TOGGLE_OK_SECRETARIA, payload: { contentId, okSecretaria: newValue } });
        try {
            await axios.patch(`/DisciplineOfferContents/${contentId}`, { okSecretaria: newValue });
        } catch (e) {
            console.error("toggleOkSecretaria ERROR", e);
            // Revert on failure
            dispatch({ type: TOGGLE_OK_SECRETARIA, payload: { contentId, okSecretaria: currentValue } });
            throw e;
        }
    }
}


export const fetchBatchDofContents = (dofIds: number[]) => {
    return async (dispatch: any) => {
        dispatch({ type: FETCH_BATCH_DOF_CONTENTS });
        try {
            if (dofIds.length === 0) {
                dispatch({ type: RECEIVE_BATCH_DOF_CONTENTS, payload: {} });
                return;
            }
            const filter = encodeURIComponent(JSON.stringify({
                where: { DisciplineOffer_id: { inq: dofIds } },
                order: "Date"
            }));
            const response = await axios.get(`/DisciplineOfferContents?filter=${filter}`);
            const map: { [key: number]: any[] } = {};
            (response.data || []).forEach((c: any) => {
                const dofId = c.DisciplineOffer_id;
                if (!map[dofId]) map[dofId] = [];
                map[dofId].push(c);
            });
            dispatch({ type: RECEIVE_BATCH_DOF_CONTENTS, payload: map });
        } catch (e) {
            console.error("fetchBatchDofContents ERROR", e);
            dispatch({ type: RECEIVE_BATCH_DOF_CONTENTS, payload: {} });
        }
    }
}


export const getAtaPresencaBatchData = (items: { dofId: number, contentId: number }[]) => {
    return async (dispatch: any) => {
        dispatch({ type: FETCH_ATA_PRESENCA_BATCH });
        try {
            // Group by dofId to avoid redundant API calls
            const dofGroups: { [key: number]: number[] } = {};
            items.forEach(item => {
                if (!dofGroups[item.dofId]) dofGroups[item.dofId] = [];
                dofGroups[item.dofId].push(item.contentId);
            });

            const atas: any[] = [];
            const dofIds = Object.keys(dofGroups).map(Number);

            for (let di = 0; di < dofIds.length; di++) {
                const dofId = dofIds[di];
                const contentIds = dofGroups[dofId];
                // Fetch header
                const headerFilter = encodeURIComponent(JSON.stringify({
                    where: { id: dofId },
                    include: [{ classOffer: "level" }, { discipline: "level" }, "disciplineModule", "teacher", "period"]
                }));
                const headerResponse = await axios.get(`/DisciplineOffers?filter=${headerFilter}`);
                const header = headerResponse.data[0] || {};

                // Fetch students and frequency (once per DOF)
                const alunosResponse = await axios.get(
                    config.BASE_URL + `/DisciplineOffers/getStudentsListForFrequencyCallPrint?params={"dofId":${dofId}}`
                );
                const frequenciaResponse = await axios.get(
                    config.BASE_URL + `/DisciplineOffers/getFrequencyCallForPrint?params={"dofId":${dofId}}`
                );

                const alunos = alunosResponse.data || [];
                const frequencia = frequenciaResponse.data || [];

                // For each content in this DOF
                for (const contentId of contentIds) {
                    const contentResponse = await axios.get(`/DisciplineOfferContents/${contentId}`);
                    const content = contentResponse.data;
                    const qtyHours = content.QtyHours || 1;

                    const alunosComFrequencia: any[] = [];
                    alunos.forEach((aluno: any) => {
                        const freq = frequencia.filter(
                            (f: any) => f.DisciplineEntree_id === aluno.deeId
                                && f.DisciplineOfferContent_id === contentId
                                && f.Type === 1
                        );
                        const presencas: boolean[] = [];
                        for (let i = 0; i < qtyHours; i++) {
                            presencas.push(freq[i] ? freq[i].Status === 1 : false);
                        }
                        alunosComFrequencia.push({
                            name: aluno.Name || aluno.name || '',
                            deeId: aluno.deeId,
                            presencas
                        });
                    });

                    const alunosComPresenca = alunosComFrequencia.filter(
                        (a: any) => a.presencas.some((p: boolean) => p)
                    );
                    alunosComPresenca.sort((a: any, b: any) => a.name.localeCompare(b.name));

                    atas.push({ header, content, alunos: alunosComPresenca });
                }
            }

            dispatch({ type: RECEIVE_ATA_PRESENCA_BATCH, payload: atas });
        } catch (e) {
            console.error("getAtaPresencaBatchData ERROR", e);
            dispatch({ type: RECEIVE_ATA_PRESENCA_BATCH, payload: [] });
        }
    }
}


export const markBatchAtaGerada = (contentIds: number[]) => {
    return async (dispatch: any) => {
        try {
            for (const id of contentIds) {
                await axios.patch(`/DisciplineOfferContents/${id}`, { isAtaGerada: true });
            }
        } catch (e) {
            console.error("markBatchAtaGerada ERROR", e);
        }
    }
}